import { Modal } from '@sb1/ffe-modals-react';
import InstagramShareInstructionsModalBlock from './InstagramShareInstructionsModalBlock';

export default function InstagramShareInstructionsModal({
    ref,
    urlToShare,
    projectTitle,
    projectId,
    trackingProperties,
    showBackButton = true,
}) {
    return (
        <Modal ref={ref} ariaLabelledby={'share-modal-title'}>
            <InstagramShareInstructionsModalBlock
                ref={ref}
                urlToShare={urlToShare}
                projectId={projectId}
                projectTitle={projectTitle}
                trackingProperties={trackingProperties}
                onBack={showBackButton ? () => ref?.current?.close() : undefined}
            />
        </Modal>
    );
}
